import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import EditUserScreen from "../screens/EditUserScreen";
import UserListScreen from "../screens/UserListScreen";
import NewUserScreen from "../screens/NewUserScreen";
import UserProfileScreen from "../screens/UserProfileScreen";

type UsersRouterProps = {} & RouteComponentProps;

const UsersRouter: React.FC<UsersRouterProps> = ({ match }) => (
  <Switch>
    <Route path={`${match.path}/new`} exact component={NewUserScreen} />
    <Route path={`${match.path}/:id`} exact component={UserProfileScreen} />
    <Route path={`${match.path}/:id/edit`} exact component={EditUserScreen} />
    <Route path={`${match.path}`} exact component={UserListScreen} />
  </Switch>
);

export default UsersRouter;
